import cx from 'classnames';

function RecaptchaText({ classes, children, calmMode }) {
  const recaptchaText = () => {
    if (calmMode) {
      return (
        <>
          This site is protected by reCAPTCHA and the{' '}
          <a href='https://policies.google.com/privacy'>
            Google Privacy Policy
          </a>{' '}
          and{' '}
          <a href='https://policies.google.com/terms'>
            Terms&nbsp;of&nbsp;Service
          </a>
          &nbsp;apply.
        </>
      );
    } else {
      return (
        <>
          This site is protected by reCAPTCHA and the Google{' '}
          <a href='https://policies.google.com/privacy'>Privacy Policy</a> and{' '}
          <a href='https://policies.google.com/terms'>
            Terms&nbsp;of&nbsp;Service
          </a>
          &nbsp;apply.
        </>
      );
    }
  };

  return (
    <p className={cx('leading-snug recaptcha-text', classes)}>
      {children}
      {recaptchaText()}
    </p>
  );
}

export default RecaptchaText;
